import qs from 'qs';
import { useSSRContext } from 'vue';

// 构建环境
export enum BuildEnv {
  prod = 'prod',
  pre = 'pre',
  uat = 'uat',
  dev = 'dev',
  development = 'development',
  production = 'production'
}

// 业务环境
export enum BizEnv {
  prod = 'prod',
  pre = 'pre',
  uat = 'uat',
  dev = 'dev',
}

// 宿主环境
export interface HostingEnv {
  isSSR: boolean;
  isMobile?: boolean;
  isAndroid?: boolean;
  isiOS?: boolean;
  isBrowser: boolean;
  isSafari?: boolean;
  isChrome?: boolean;
  isFirefox?: boolean;
  isOpera?: boolean;
  isIE?: boolean;
  isInApp?: boolean;
  ua?: string;
}

export interface SSRContext {
  url: string
  path: string
  userAgent: string
  querystring: string
  query: Record<string, string | number>
  cookie: string
  region: string
  lang: string
  headers: Record<string, string | number>
}

export const EnvMap: Record<BuildEnv, BizEnv> = {
  [BuildEnv.dev]: BizEnv.dev,
  [BuildEnv.uat]: BizEnv.uat,
  [BuildEnv.pre]: BizEnv.pre,
  [BuildEnv.prod]: BizEnv.prod,
  [BuildEnv.development]: BizEnv.dev,
  [BuildEnv.production]: BizEnv.prod,
};

export const getEnv = (): BizEnv => {
  const buildEnv = process.env.NODE_ENV as BuildEnv || BuildEnv.prod;
  let bizEnv = EnvMap[buildEnv];
  if (bizEnv === BizEnv.dev && typeof window !== 'undefined') {
    bizEnv = qs.parse(location.search.slice(1)).env as BizEnv || BizEnv.dev;
  }
  return bizEnv;
};

export const useHostingEnv = (): HostingEnv => {
  const isBrowser = typeof window !== 'undefined';
  const isSSR = import.meta.env.SSR;
  let ua;

  if (isSSR && !isBrowser) {
    const ssrContext = useSSRContext<SSRContext>();
    ua = ssrContext?.userAgent;
  } else {
    ua = navigator.userAgent;
  }

  if (ua) {
    return {
      ua,
      isSSR,
      isBrowser,
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua),
      isAndroid: ua.includes('Android') || ua.includes('Adr'),
      isiOS: (/\(i[^;]+;( U;)? CPU.+Mac OS X/i).test(ua), // ios 终端
      isSafari: ua.includes('Safari') && !ua.includes('Chrome'),
      isChrome: ua.includes('Chrome'),
      isFirefox: ua.includes('Firefox'),
      isOpera: ua.includes('Opera'),
      isIE: isBrowser && (!!window.ActiveXObject || 'ActiveXObject' in window),
      isInApp: (/bstar_[a|i]/i).test(ua),
    };
  }

  return {
    ua,
    isSSR,
    isBrowser,
  };
};